export interface ResumeHiringDialogData {
  title: string;
  description: string;
  question: string;
  actions: {
    primary: string,
    secondary: string;
  };
}

export interface ResumeHiringDialogResult {
  action: RESUME_HIRING_ACTIONS;
}

export enum RESUME_HIRING_ACTIONS {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  CLOSE = 'CLOSE'
}
